export const colors = {
  blue: '#3498DB',
  orange: '#F39C12',
  green: '#27AE60',
  purple: '#8064A2',
  blue100: '#133c84',
  blue80: '#1966c2',
  blue40: '#9EB8CF',
  blue20: '#CEDCE7',
  yellow100: '#E39F19',
  yellow80: '#f5ca44',
  black: '#000000',
  white: '#ffffff',
  gray: '#DDD8D8',
  red: '#E74C3C',
  chart: {
    warning: '#f5ca44',
    critical: '#FF0000',
    normal: '#133c84',
    ambient: '#F39C12',
    maximum: '#E74C3C',
    minimum: '#3498DB',
    mean: '#27AE60',
    median: '#8064A2'
  },
  rgs: {
    location: '#2ECC71', // Leafy green — fresh, stable, map-like
    speed: '#FFA500', // Bright orange - energetic but not too harsh
    speed_accuracy: '#E91E63', // Strong pink - stands out clearly
    heading: '#2C3E50', // Deep blue-gray - good for direction
    heading_accuracy: '#8E44AD', // Muted purple - contrasts with heading
    position_accuracy: '#C0392B', // Deep red - alert but not oversaturated
    voltage: '#2980B9', // Strong blue - clean and electric feel
    current: '#16A085' // Teal - fresh and tech-friendly
  }
}

export const pageSizeOptions = [10, 25, 50, 100, 500, 1000]

export const paginationDefaults = (total, limit, setLimit, page, setPage) => {
  return {
    position: total > limit ? ['topRight', 'bottomRight'] : ['bottomRight'],
    total: total,
    current: Number(page) || 1,
    pageSize: limit,
    pageSizeOptions: pageSizeOptions,
    showSizeChanger: !!setLimit,
    onChange: (_page, _limit) => {
      if (_page !== page && !!setPage) setPage(_page)
      if ((_limit !== limit) & !!setLimit) setLimit(_limit)
      // document.querySelector('main').scrollIntoView()
    },
    className: 'pagination'
  }
}

export const widthSmall = window.innerWidth * 0.3
export const widthMedium = window.innerWidth * 0.45
export const widthLarge = window.innerWidth * 0.95

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
